<!-- Image -->
<div class="bm--hover-effect bm--hover-effect--producer" routerLink="/bm/{{ producer.id }}">
  <img loading="lazy" src="{{ producer.images.original }}" alt="{{ producer.name }} avatar" />
</div>

<!-- Name -->
<div class="producer-item__name">
  @if (producer?.verified) {
    <bmcore-verify-icon class="producer-item__icon"></bmcore-verify-icon>
  }
  <div class="producer-item__dots">
    <a class="common-bmstv-title-1" routerLink="/bm/{{ producer.id }}">{{ producer.name }}</a>
  </div>
</div>

<!-- Beats count -->
<div class="producer-item__beats">
  <p class="common-bmstv-title-2 common-bmstv-title-2--without-hover">{{ pluralizedBeatsCount }}</p>
</div>
